import React, {useEffect} from 'react';
import {Outlet} from "react-router";

function Documents() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return <div className={"documents-content"}>
        <Outlet/>
    </div>
}

export default Documents;